{
  "fr": {
    "audioRecorder": {}
  }
}
